import { HistoryContainer, TitleDescription, TitleTimeline, HorizontalTimelineContainer } from './History.style'
import HorizontalTimeline from '../HorizontalTimeline/HorizontalTimeline'
import ImageTimeline from '../../assets/Timeline/HorizontalTimeline/image.png'

const History = () => {
    return(
        <HistoryContainer>
            <TitleTimeline>
            <TitleDescription>
                <p>desde</p>
                <p>2004</p>
            </TitleDescription>
            </TitleTimeline>
            <HorizontalTimelineContainer>
              <HorizontalTimeline />
              <img src={ImageTimeline} alt='ImageTimeline' style={{marginTop: '-74px', marginLeft: '-40px'}}/>
            </HorizontalTimelineContainer>
        </HistoryContainer>
    )
}

export default History